module.exports = __webpack_public_path__ + "img/ai1.9f6f9cd4.png";